import { render } from "./Department-details.vue?vue&type=template&id=955e15d4&scoped=true"
import script from "./Department-details.vue?vue&type=script&lang=js"
export * from "./Department-details.vue?vue&type=script&lang=js"

import "./Department-details.vue?vue&type=style&index=0&id=955e15d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-955e15d4"

export default script